<template>
  <div class="email">
    <!-- TODO добавить переводы -->
    <p class="text">Now we will create your account. <br> Please, enter your email</p>
    <app-text-input label="Email" v-model="email" type="email"/>
    <div class="already-have">
      Already have an account?
      <router-link to="/auth/login">Sign in</router-link>
    </div>
    <app-btn :loading="loading" @click="next">{{$ml.get('next')}}</app-btn>
  </div>
</template>

<script>
import { QuickRegAPI } from '@/api';
import { ErrorHandlerMixin } from '@/mixins/error-handler.mixin'

export default {
  mixins: [ ErrorHandlerMixin ],

  data() {
    return {
      email: '',
      loading: false,
    }
  },

  created() {
    const name = this.$route.params.plan;
    ga('ecommerce:addItem', {
      'id': '1',
      'name': name,
      'category': 'Product',
      'price': this.$store.getters['appvars/get'](`plans-${name}-price`),
      'quantity': '1',
      'currency': 'GPB',
    });

    if(name == 'impact') {
      fbq('track', 'InitiateCheckout', {content_name:'Impact', content_category: 'Our Product' });
    }
    else if(name == 'exact') {
      fbq('track', 'InitiateCheckout', {content_name:'Exact', content_category: 'Our Product' });
    }
    else if(name == 'premium') {
      fbq('track', 'InitiateCheckout', {content_name:'Premium', content_category: 'Our Product' });
    }
    else if(name == 'elite') {
      fbq('track', 'InitiateCheckout', {content_name:'Elite', content_category: 'Our Product' });
    }
  },

  methods: {


    next() {
      this.loading = true;
      QuickRegAPI.reg(this.email).then(res => {
        this.$store.commit('user/auth', res.data.access_token);
        this.$store.dispatch('user/updateData').then(() => {
          this.$router.push('payment');
        }).finally(() => {
          this.loading = false;
        });
      })
        .catch(this.handleErrorAsNotifications)
        .then(err => {
          this.loading = false;
          // console.log(err.response.data.err.email);
          if(err.response.data.err.email == 'The email has already been taken.') {
            console.log('openSHit');
            this.$store.commit('modals/prompt/open', {
              onAccept: () => {
                this.$router.push('/auth/forgot-password')
              },
              onCancel: () => {

              },
              text: 'Looks like you already registered with this email, please, use another one. Or maybe you want to reset password?',
            });
          }
        });
    }
  },
}
</script>

<style lang="scss" scoped>

.email {
  background: #fff;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .text {
    width: 300px;
    margin-bottom: 30px;
    padding: 10px;
    border-radius: 5px;
    background: #f7f7f7;
    border-left: 3px solid $mainGreen;
    line-height: 1.5;
  }

  .already-have {
    font-size: 14px;
    width: 300px;
    color: #666;
  }

  .app-text-input {
    width: 300px;
    margin-bottom: 5px;
  }

  .app-btn {
    margin-top: 20px;
  }
}

</style>
